import { Link, type LinkProps } from 'react-resource-router';

import { token } from '@atlaskit/tokens';

export const TestLink = ({ children, ...props }: LinkProps) => {
  return (
    <Link
      style={{ color: token('color.text'), minWidth: 0, flex: 1 }}
      {...props}
    >
      {children}
    </Link>
  );
};
